import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import JoinMeetUpModal from '../../../components/JoinMeetUpModal';
import {OPTIONS} from '../../../constants/meetupOptions';
import {EventRSVPStatus} from '../../../hooks/useEvent';
import RSVPController from '../../Event/RSVP/RSVPController';
import RSVPRestrictionModal from '../../Event/RSVP/RSVPRestrictionModal';

const MeetupRSVPButton = ({event, isPreview}) => {
  const [isSelectOpen, setSelectIsOpen] = useState(false);
  const [isModalOpen, setModalIsOpen] = useState(false);
  const [isRestrictionModalOpen, setIsRestrictionModalOpen] = useState(false);
  const navigate = useNavigate();
  const noStatus =
    !event.rsvp_status.status_value || event.rsvp_status.status_value == EventRSVPStatus.NO_STATUS;

  // Check if user can RSVP to this event
  const canRsvp = event.can_rsvp !== false;

  const onClickRSVPModal = () => {
    setSelectIsOpen(false);
  };

  const onClickRSVPButton = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // If user cannot RSVP due to membership restrictions, show upgrade modal
    if (!canRsvp && event.rsvp_restriction_reason === 'local_insiders_membership_required') {
      setIsRestrictionModalOpen(true);
      return;
    }
    
    // On preview pages, don't allow RSVP actions (but still show restriction modal above)
    if (isPreview) {
      return;
    }
    
    if (noStatus) {
      setModalIsOpen(true);
    } else {
      setSelectIsOpen(true);
    }
  };
  
  const onUpgradeClick = () => {
    setIsRestrictionModalOpen(false);
    navigate('/memberships');
  };

  return (
    <>
      <RSVPController
        buttonProps={{width: '100%'}}
        event={event}
        rsvpOptions={OPTIONS}
        onButtonClick={onClickRSVPButton}
        optionClickCallback={onClickRSVPModal}
        openModal={isSelectOpen}
        onModalClose={() => setSelectIsOpen(false)}
      />
      <JoinMeetUpModal
        event={event}
        show={isModalOpen}
        setShow={setModalIsOpen}
        //routeAfterCreate={false}
      />
      <RSVPRestrictionModal
        isOpen={isRestrictionModalOpen}
        onClose={() => setIsRestrictionModalOpen(false)}
        onUpgradeClick={onUpgradeClick}
      />
    </>
  );
};

export default MeetupRSVPButton;
